







































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { formatCurrency } from "@/shared/currency";
import moment from "moment";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { usePersonalContributionSchedulesStore } from "@/shared/store/personalContributionSchedules";
import { TransferSchedule } from "@/shared/types";
import { formatMMMDateString } from "@/shared/dateString";

interface ContributionRow {
  postDate: string;
  amount: string;
  bankAccountName: string;
  year: number;
}

@Component ({
  components: {
    GenericLoadingSpinner,
    Pagination
  }
})
export default class ProposedScheduleTable extends Vue {

  bankAccountStore = useBankAccountStore();
  contributionSchedulesStore = usePersonalContributionSchedulesStore();

  formatCurrency = formatCurrency;
  tableRows: ContributionRow[] = [];

  tableFields = [
    {
      key: "postDate",
      label: "Post Date",
      thClass: "color-primary"
    },
    {
      key: "amount",
      label: "Amount",
      thClass: "color-primary"
    },
    {
      key: "bankAccountName",
      label: "Bank Account",
      thClass: "color-primary"
    },
    {
      key: "year",
      label: "Tax Year",
      thClass: "color-primary"
    }
  ];

  @Prop({required: true})
  schedule: TransferSchedule;

  @Prop({required: true})
  page: number;

  mounted (): void {
    this.bankAccountStore.loadLinkedBankAccounts();

    const args = {
      proposedSchedule: this.schedule,
      toDate: moment().add(1, "years").format("YYYY-MM-DD"),
      numberOfCalendarEntries: 3
     };
    this.contributionSchedulesStore.getProposedPersonalContributionScheduleCalendars(args).then(() => this.loadPage());
  }

  get isLoaded (): boolean {
    return this.bankAccountStore.linkedAccountsLoaded &&
      this.contributionSchedulesStore.proposedPersonalContributionScheduleCalendarsLoaded;
  }

  @Watch("page")
  loadPage () {
    this.tableRows = this.buildTableRows();
  }

  buildTableRows (): ContributionRow[] {
    if (!this.isLoaded) {
      return [];
    }

    return this.contributionSchedulesStore.proposedContributionsPage(this.page).map(x => {
      return {
        postDate: this.getFormattedDate(x.calendarDate),
        amount: formatCurrency(x.amount),
        bankAccountName: this.getAccountName(x.linkedExternalBankAccountId),
        year: moment(x.calendarDate).year()
      };
    });
  }

  getFormattedDate (date?: string): string {
    return date && formatMMMDateString(date) || "None";
  }

  getAccountName (accountId: number | string): string {
    const index = this.bankAccountStore.verifiedLinkedAccounts.findIndex(x => x.linkedBankAccountId === accountId);
    if (index < 0) {
      return accountId.toString();
    }

    return this.bankAccountStore.verifiedLinkedAccounts[index].bankAccountName;
  }

  switchPage (newPage) {
    if (newPage !== this.page) {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          page: newPage
        }
      });
    }
  }
}
